import { useTranslation } from 'react-i18next'
import Button from '../../components/buttons/Button'
import SignOutIcon from '../../components/icons/SignOutIcon'
import useAuth from '../../hooks/useAuth'
import { useAppSelector } from '../../hooks/useStore'

const LogoutButton = () => {
  const { logOut } = useAuth()
  const { t } = useTranslation()
  const { isToggle } = useAppSelector((state) => state.dashboardUi.sidebar)
  const handleLogoutClick = () => {
    logOut()
  }
  return (
    <div className='px-6 mt-7'>
      {isToggle ? (
        <SignOutIcon
          classes='text-gray-400 hover:text-blue-400 mb-4'
          title={t('logoutFromAccount')}
          isSidebarMenuToggle={isToggle}
          handleClick={handleLogoutClick}
        />
      ) : (
        <Button classes='w-full mb-2' icon={<SignOutIcon />} onClick={handleLogoutClick}>
          {t('logoutFromAccount')}
        </Button>
      )}
    </div>
  )
}

export default LogoutButton
